import { useRootService } from '@kaokei/use-vue-service';
import analysisSdk from '@hetao/analysis-web-sdk';
import { ZoneService } from '~/services/zone.service';
import { getAdtagFromUrl, getInviterFromUrl } from '~/utils/utility';
import { version } from '../package.json';
import { isProd } from './environment';

window.analysisSdk = analysisSdk;

// https://npm.corp.hetao101.com/#/detail/@hetao/analysis-web-sdk
window.hetaoTrack = (eventName: any, props = {}, eventObj?: any) => {
  const zoneService = useRootService(ZoneService);
  const adtag = getAdtagFromUrl();
  const inviter = getInviterFromUrl();
  window.analysisSdk.track(
    eventName,
    {
      context: {
        oj: {
          zone: zoneService.zone,
          project_version: '20250418',
          adtag,
          inviter,
          ...props,
        },
      },
    },
    eventObj,
  );
  window.__bl.addBehavior({
    type: 'custom',
    data: {
      eventName,
      zone: zoneService.zone,
      ...props,
    },
  });
};

export function initAnalysisSdk() {
  const IS_PROD = isProd();

  analysisSdk.init({
    // 当前的环境testing  or  production
    env: IS_PROD ? 'production' : 'testing',
    // 埋点项目版本，实际值使用客户端开发迭代的版本，即埋点版本和客户端版本保持一致
    version,
    // userId:"55090", //用户的id 没有userId时可不传，等后续获取到userId后 通过update方法传入
    // userId: analysisSdk.getUUID(),
    product: 'fe_oj_ninja', // 核桃OJ系统
    // optional
    // 是否第三方神策 可以不传 默认为true
    sensors: true,
    // 是否调用数仓 可以不传 默认为true
    inside: false,
    // 是否打印log********s
    logs: !IS_PROD,
    geolocation: {
      // 表示当前的经纬度，如果传入，sdk中则不自动获取
      latitude: '',
      longitude: '',
    },
    sensorInit: {
      batch_send: {
        datasend_timeout: 6000, // 一次请求超过多少毫秒的话自动取消，防止请求无响应。
        send_interval: 2000, // 间隔多少毫秒发一次数据。
        storage_length: 200, // 存储 localStorage 条数最大值，默认：200 。如 localStorage 条数超过该值，则使用 image 方式立即发送数据。v1.24.8 以上支持。
      },
      heatmap: {
        clickmap: 'not_collect',
        scroll_notice_map: 'default',
      },
    },
    // 数仓埋点地址， 内置地址如下, 如果确认使用此地址，则不需要指定envUrl
    // testing: "http://datacenter.testing.hetao101.com/app/eventdata/transfer/v1",
    // production: "https://datacenter.hetao101.com/app/eventdata/transfer/v1"
    // envUrl: 'https://datacenter.hetao101.com/app/eventdata/transfer/v1',
    envUrl: IS_PROD
      ? undefined
      : 'https://datacenter.testing.hetao101.com/app/eventdata/transfer/v1',
  });
}
